import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRoleList } from "reduxStore/action/roleActions";
import {
  getUserFilterDetail,
  getUserList,
  userStatusUpdate,
} from "reduxStore/action/usersActions";
import TableDataNotFound from "component/TableDataNotFound";
import strings from "translate/language";
import moment from "moment";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Pagination from "component/common/Pagination";
import usePermission from "utils/usePermission";
import usePage from "utils/usePage";
import Button from "../../component/Button";
import { ChannelPartner, CPAgent } from "utils/constants";
import Select from "react-select";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import { getCityList } from "reduxStore/action/masterActions";

const User = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const roleId = params.get("role_id");
  const [page, setPage] = usePage();
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [handleStatus, setHandleStatus] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [userList, setUserList] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    role_id: "",
    search_name: "",
    email: "",
    status: "",
    _id: "",
    city_id: "",
  });
  const [selectedusers, setSelectedusers] = useState([]);
  const [selectAllCheckbox, setSelectAllCheckbox] = useState(false);
  const userListSelector = useSelector((state) => state?.userData) || [];
  const getRoleListSelector = useSelector((state) => state.roleData) || {};
  const ReportListSelector = useSelector((state) => state.report);
  const GetCityListSelector =
    useSelector((state) => state.cityMasterData?.response?.data) || [];

  const { create, view, edit } = usePermission({
    create: "add_user",
    view: "user_detail",
    edit: "edit_user",
  });
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    seo({
      title: "Users Listing",
      metaDescription: "All registered user list",
      canonicalLink: window.location.href,
    });
  }, []);

  useEffect(() => {
    const { reportPropertyList } = ReportListSelector;
    if (reportPropertyList) {
      if (reportPropertyList?.status === 200) {
        setPropertyList(handleListResponse(reportPropertyList.data));
      } else {
        setPropertyList([]);
      }
    }
  }, [ReportListSelector]);

  useEffect(() => {
    dispatch(getUserFilterDetail({ limit: 10, offset: page, role_id: roleId }));
  }, [dispatch]);

  useEffect(() => {
    const { response } = getRoleListSelector;
    if (response) {
      if (response?.status === 200) {
        let filterData = handleListResponse(response.data).filter(
          (i) => i._id !== CPAgent && i._id !== ChannelPartner
        );
        setRolesData(filterData);
      } else {
        setRolesData([]);
      }
    }
  }, [getRoleListSelector]);

  useEffect(() => {
    selectAllCheckBoxVal();
  }, []);

  const handlePageClick = (newOffset) => {
    window.scroll(0, 0);
    setPage(newOffset);
    let params = {
      limit: 10,
      offset: newOffset,
      start_date: form.start_date,
      end_date: form.end_date,
      role_id: roleId ? roleId : form.role_id,
      search_name: form.search_name,
      email: form.email,
      status: form.status,
      property_id: form?.site?._id,
      city_id: form.city_id,
    };

    dispatch(getUserFilterDetail(params));
  };

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getUserFilterDetail({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          role_id: roleId ? roleId : form.role_id,
          search_name: form.search_name,
          email: form.email,
          status: form.status,
          property_id: form?.site?._id,
          city_id: form.city_id,
          filtertype: true,
        })
      );
      setPage(0);
    }
  };
  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      role_id: "",
      search_name: "",
      email: "",
      status: "",
      site: "",
      cityObj: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    dispatch(getUserFilterDetail({ limit: 10, offset: 0, role_id: roleId }));
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handleUserStatus = () => {
    dispatch(userStatusUpdate(handleStatus));
  };

  useEffect(() => {
    if (userListSelector.create) {
      if (userListSelector?.userData?.status === 200) {
        if (handleStatus.user_id) {
          dispatch(getUserList({ limit: 10, offset: page }));
        }
        setHandleStatus({});
      }
    } else {
      if (userListSelector?.userData?.status === 200) {
        if (userListSelector?.userData?.data?.length > 0) {
          setUserList(
            handleListResponse(userListSelector?.userData?.data)
              ? userListSelector?.userData?.data
              : []
          );
        }
        var areAllElementsPresent =
          userListSelector?.userData?.data?.length &&
          userListSelector?.userData?.data.every((element) =>
            selectedusers.includes(element.login_id)
          );
        setSelectAllCheckbox(areAllElementsPresent);
      } else {
        setUserList([]);
      }
    }
  }, [dispatch, userListSelector]);

  useEffect(() => {
    dispatch(getRoleList());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCityList());
  }, [dispatch]);

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  const selectAllCheckBoxVal = (e) => {
    const res = e ? e.target.checked : false;
    const getIds = userList?.map((user) => user.login_id);
    if (res) {
      const arr = [...selectedusers, ...getIds];
      const uniqueIds = [...new Set(arr)];
      setSelectedusers(uniqueIds);
      setSelectAllCheckbox(true);
    } else {
      setSelectAllCheckbox(false);
      const unmatchedInArr1 = userList.filter(
        (item) => !selectedusers.includes(item.login_id)
      );
      const unmatchedInArr2 = selectedusers.filter(
        (item) => !userList.map((obj) => obj.login_id)?.includes(item)
      );
      const dd = [...unmatchedInArr1, ...unmatchedInArr2];
      setSelectedusers(dd);
    }
  };

  const handleSelectUser = (status, item, index) => {
    const checkAlreadySel = selectedusers.findIndex(
      (user) => user === item.login_id
    );
    const arr = [...selectedusers];
    if (checkAlreadySel === -1) {
      arr.push(item.login_id);
    } else {
      arr.splice(checkAlreadySel, 1);
    }
    setSelectedusers(arr);
    var areAllElementsPresent = userList.every((element) =>
      arr.includes(element.login_id)
    );
    setSelectAllCheckbox(areAllElementsPresent);
  };

  return (
    <div className="page-body">
      {/* Model_start */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {handleStatus.status
                  ? strings.activeUser
                  : strings.deactiveUser}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <h6>{strings.areYouSure}</h6>
              </div>
              <div className="text-center">
                <h6>
                  {handleStatus.status
                    ? strings.activeThisUser
                    : strings.deactiveThisUser}
                </h6>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleUserStatus()}
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end */}
      <Breadcrumb
        title={strings.user}
        parentListing={null}
        titleactive={strings.userListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.byRole}</span>
                          <select
                            className="form-control digits"
                            id="exampleFormControlSelect9"
                            name="role_id"
                            value={form.role_id}
                            onChange={handleInputField}
                          >
                            <option value="">{strings.selectRole}</option>
                            {rolesData.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.role_title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByName}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="search_name"
                              value={form.search_name}
                              onChange={handleInputField}
                              placeholder={strings.searchName}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByEmail}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="email"
                              name="email"
                              value={form.email}
                              onChange={handleInputField}
                              placeholder={strings.searchEmail}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="exampleFormControlSelect9"
                            name="status"
                            value={form.status}
                            onChange={(event) => handleInputField(event)}
                          >
                            <option defaultValue={null}>
                              {strings.selectstatus}
                            </option>
                            <option value={"1"}>{strings.active}</option>
                            <option value={"2"}>{strings.deactive}</option>
                          </select>
                        </div> */}
                        <div className="col-md-4 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <Button
                              className="btn btn-warning mr-4"
                              onClick={filterDetail}
                              label={strings.search}
                            ></Button>
                            <Button
                              className="btn btn-dark"
                              onClick={filterReset}
                              label={strings.reset}
                            >
                              {strings.reset}
                            </Button>
                          </div>
                        </div>
                      </div>

                      {/* <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByPropertyName}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (e.length > 1) {
                                dispatch(
                                  getReportPropertyList({
                                    search_site: e,
                                    isLoadMore: true,
                                  })
                                );
                              } else {
                                dispatch(
                                  getReportPropertyList({
                                    limit: 10,
                                    offset: 0,
                                    isLoadMore: true,
                                  })
                                );
                              }
                            }}
                            placeholder={strings.searchByPropertyName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByCity}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            placeholder={strings.searchByCity}
                            options={GetCityListSelector}
                            getOptionLabel={(option) => `${option.city_name}`}
                            getOptionValue={(option) => option.city_id}
                            name="cityObj"
                            value={form.cityObj}
                            onChange={(val) => {
                              const nextFormState = {
                                ...form,
                                cityObj: val,
                              };
                              if (val) {
                                nextFormState.city = val?.city_name;
                                nextFormState.city_id = val?.city_id;
                              } else {
                                nextFormState.city = "";
                                nextFormState.city_id = "";
                              }
                              setForm(nextFormState);
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <span className="cardText">
                            {strings.searchByParentName}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (e.length > 1) {
                                dispatch(
                                  getUserFilterDetail({
                                    search_user: e,
                                    isLoadMore: true,
                                  })
                                );
                              } else {
                                dispatch(
                                  getUserFilterDetail({
                                    limit: 10,
                                    offset: 0,
                                    isLoadMore: true,
                                  })
                                );
                              }
                            }}
                            placeholder={strings.searchByParentName}
                            options={userList}
                            getOptionLabel={(item) =>
                              `${item.firstname} ${item.lastname} (${item.role_title})`
                            }
                            getOptionValue={(item) => item._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                        <div className="col-md-4 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <Button
                              className="btn btn-warning mr-4"
                              onClick={filterDetail}
                              label={strings.search}
                            ></Button>
                            <Button
                              className="btn btn-dark"
                              onClick={filterReset}
                              label={strings.reset}
                            >
                              {strings.reset}
                            </Button>
                          </div>
                        </div>
                      </div> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {create && (
              <div className="row pt-3">
                <div className="col-md-12 d-flex justify-content-between">
                  <div className="form-group">
                    {/* <Button
                      className="btn btn-color"
                      onClick={() => navigatpage("/addnewuser")}
                      label={strings.addNewUser}
                    ></Button> */}
                  </div>
                  {/* <div className="form-group mr-4">
                    <Button
                      className="btn btn-color"
                      // onClick={() => navigatpage("/addnewuser")}
                      label={strings.userPasswordSend}
                    ></Button>
                  </div> */}
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfUsers}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr className="text-center">
                          {/* <th scope="col" style={{ inlineSize: "91px" }}>
                            <span>{strings.selectall}</span>
                            <input
                              style={{ cursor: "pointer" }}
                              type="checkbox"
                              className="ml-2"
                              onChange={selectAllCheckBoxVal}
                              checked={selectAllCheckbox ? true : false}
                            />
                            <span></span>
                          </th> */}
                          <th scope="col">{strings.name}</th>
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.contactNo}</th>
                          <th scope="col">{strings.emailId}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.role}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userList?.length ? (
                          userList.map((item, index) => {
                            return item.role_title !== "Super Admin" ? (
                              <tr className="text-center" key={index}>
                                {/* <td
                                  className="transform"
                                  style={{ inlineSize: "70px" }}
                                >
                                  <input
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    onChange={(e) =>
                                      handleSelectUser(
                                        e.target.checked,
                                        item,
                                        index
                                      )
                                    }
                                    checked={
                                      selectedusers.some(
                                        (user) => user === item.login_id
                                      )
                                        ? true
                                        : false
                                    }
                                  />
                                </td> */}
                                <td
                                  className="transform"
                                  style={{ inlineSize: "130px" }}
                                >
                                  {item.firstname + " " + item.lastname}
                                </td>
                                <td>
                                  {moment(item.created_date).format(
                                    "DD-MM-yyyy hh:mm a"
                                  )}
                                </td>
                                <td>{item.mobile ? item.mobile : "-"}</td>
                                <td>{item.email}</td>
                                <td
                                  style={{
                                    color: item.status ? "green" : "red",
                                    fontWeight: item.status ? "500" : "500",
                                  }}
                                >
                                  {item.status ? "Active" : "Deactive"}
                                </td>
                                <td>{item.role_title}</td>
                                <td className="p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-1"
                                      aria-hidden="true"
                                      title={strings.viewUser}
                                      onClick={() => {
                                        navigatpage(`/viewuser/${item._id}`);
                                      }}
                                    ></i>
                                  )}
                                  {/* {edit && (
                                    <i
                                      className="fa fa-edit theme-fa-icon p-1"
                                      aria-hidden="true"
                                      title={strings.edituser}
                                      onClick={() => {
                                        navigatpage(`/edituser/${item._id}`);
                                      }}
                                    ></i>
                                  )} */}
                                  {/* {edit &&
                                    (item.status ? (
                                      <i
                                        className="fa fa-ban theme-fa-icon p-1"
                                        aria-hidden="true"
                                        title={strings.DeactiveUser}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"
                                        onClick={() =>
                                          setHandleStatus({
                                            user_id: item._id,
                                            status: false,
                                          })
                                        }
                                      ></i>
                                    ) : (
                                      <i
                                        className="fa fa-unlock theme-fa-icon p-1"
                                        aria-hidden="true"
                                        title={strings.activeUser}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"
                                        onClick={() =>
                                          setHandleStatus({
                                            user_id: item._id,
                                            status: true,
                                          })
                                        }
                                      ></i>
                                    ))} */}
                                </td>
                              </tr>
                            ) : null;
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={userList} />
                  </div>
                  <Pagination
                    totalCount={userListSelector?.userData?.total_data}
                    listData={userList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default User;
